// extracted by mini-css-extract-plugin
export default {"copyIcon":"Copyicon-module__copyIcon___E8WBl"};